import(/* webpackMode: "eager" */ "/vercel/path0/app/privacy/page.jsx");
